import * as TypeGraphQL from "type-graphql";
export var RolloutStrategy;
(function (RolloutStrategy) {
    RolloutStrategy["IMMEDIATE"] = "IMMEDIATE";
    RolloutStrategy["GRADUAL"] = "GRADUAL";
    RolloutStrategy["CANARY"] = "CANARY";
    RolloutStrategy["BLUE_GREEN"] = "BLUE_GREEN";
})(RolloutStrategy || (RolloutStrategy = {}));
TypeGraphQL.registerEnumType(RolloutStrategy, {
    name: "RolloutStrategy",
    description: undefined,
});
//# sourceMappingURL=RolloutStrategy.js.map